import React from 'react';
import styled, {css} from 'styled-components';
import downloadIcon from '../img/sprite/track-download.svg';

const StyledLink = styled.a`
  ${(props) => !props.href && css`
    pointer-events: none;
  `}`;

const DemoDownloadBtn = ({title = 'Демо', track, className = '', iconOnly = false}) => {
	if (!track) {
		return null;
	}

	if (iconOnly) {
		return (
			<StyledLink
				className={`player__interaction-button waves-effect waves-button ${className}`}
				href={track.src}
				download={`${track.code} ${track.name}`}
			>
				<img src={downloadIcon} alt="" width={24} height={24}/>
			</StyledLink>
		);
	}

	return (
		<StyledLink
			className={`button button--default waves-light button--waves button--${!!track.src ? 'success' : 'gray'} ${className}`}
			href={track.src}
			download={`${track.code} ${track.name}`}
		>
			<span className="button__content">
				{title}
			</span>
		</StyledLink>
	);
};

export default DemoDownloadBtn;
